import { sendRequestJson } from '@/utils'

class TranslationRepository {
	constructor() {
		const host = window.location.hostname
		if (host === 'localhost' || host.startsWith('192.168')) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL
		} else {
			this.urlBase = window.location.origin
		}
	}

	async getTranslations(data) {
		const url = this.urlBase + '/world/api/translations/get'
		return await sendRequestJson({ data, url, method: 'POST' }, false)
	}
}

export const translationRepository = new TranslationRepository()
